import { HTTP } from '@/api/http-shappy-common'
import { HttpFunctions } from '@/api/http-shappy-functions'

export default {
  getShappyInfo (params, callback) {
    // Mock up shappy-api
    /* HTTP.get('shappy-api.php?appId=' + params.appId + '&channelId=' + params.channelId + '&token=' + params.shappyCustomToken).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    }) */

    HTTP.get('account/' + params.appId + '/' + params.channelId + '/' + params.shappyCustomToken).then(response => {
      if (response.status === 200) {
        callback(response.data)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/shappy/index.js